<template>
  <q-page padding>
    <div class="row">
      <div class="col-12">
        <GridPesquisas />
      </div>
    </div>
  </q-page>
</template>

<script>
import GridPesquisas from './GridPesquisas'

export default {
  components: {
    GridPesquisas
  }  
}
</script>